import React from "react";
import { observer } from "mobx-react";
import { Box, Image } from "@chakra-ui/react";
import { useAppNavigate } from "@/routing/useAppNavigate";
import { PageContainer } from "./PageContainer";

export const Header = observer(() => {
  const navigate = useAppNavigate();

  return (
    <Box
      as="header"
      bg="white"
    >
      <PageContainer
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        height="74px"
      >
        <Image
          src="/images/narcan-logo.svg"
          alt="Logo"
          height="25px"
          onClick={() => navigate({ to: "/" })}
          cursor="pointer"
        />
      </PageContainer>
    </Box>
  );
});
